import React from "react";
import { Link } from "react-router-dom";
import { MINI_DRAWER } from "constants/ActionTypes";
import logo from "assets/images/vibo_vibo-white-new.png";

const SidenavLogo = ({ drawerType }) => {
  const showMini = drawerType.includes(MINI_DRAWER);

  return (
    <div className="sidebar-header d-flex align-items-center">
      <Link to="/">
        {showMini ? (
          <div className="mini-logo">
            <img className="mini-logo-img" alt="..." src="http://via.placeholder.com/32x32" />
            <img className="mini-logo-img-hover" alt="..." src={logo} />
          </div>
        ) : (
          <img
            style={{
              width: "200px",
              height: "auto",
              padding: "10px",
              top: "0",
              position: "absolute",
            }}
            alt="..."
            src={logo}
          />
        )}
      </Link>
    </div>
  );
};

export default SidenavLogo;



// WEBPACK FOOTER //
// ./components/SidenavLogo/index.js